export default  {
  OK: 'OK',
  ERROR: 'ERROR',
  PARTIAL: 'PARTIAL',
}

